// One-time data repairs for existing saves, run once per league right after it is opened. Each migration has an id;
// ids that already ran are stored in the league (gameAttributes.saveMigrations), so a repair never runs twice for the
// same league, and leagues created after the fix just record it as done. Repairs must be narrow and idempotent anyway.
import { isSport } from "../../../common/sportFunctions.ts";
import { g } from "../../util/index.ts";
import { repairInternationalFreeAgents } from "../freeAgents/repairInternationalFreeAgents.baseball.ts";
import setGameAttributes from "./setGameAttributes.ts";

const MIGRATIONS: { id: string; baseballOnly: boolean; run: () => Promise<unknown> }[] = [
	// Old generator gave immediate international free agents the future draft class's ratings year, hiding them
	// from the free agents page. See repairInternationalFreeAgents.baseball.ts for exactly what is touched.
	{ id: "international-free-agents-2026-10-29", baseballOnly: true, run: repairInternationalFreeAgents },
];

export const runSaveMigrations = async () => {
	// Old saves don't have the attribute at all, and g.get throws for unset keys
	const done = new Set(Object.hasOwn(g, "saveMigrations") ? (g.get("saveMigrations") ?? []) : []);
	const pending = MIGRATIONS.filter((m) => !done.has(m.id) && (!m.baseballOnly || isSport("baseball")));
	if (pending.length === 0) {
		return [];
	}
	for (const migration of pending) {
		await migration.run();
		done.add(migration.id);
	}
	await setGameAttributes({ saveMigrations: [...done].sort() });
	return pending.map((m) => m.id);
};
